/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ProgramasControllerActualizarEncuestaPrograma$Params {

/**
 * UUID del programa a actualizar
 */
  uuidPrograma: string;
      body: {

/**
 * Archivo Excel (.xlsx) opcional que se convertirá a JSON
 */
'file'?: Blob;
}
}

export function programasControllerActualizarEncuestaPrograma(http: HttpClient, rootUrl: string, params: ProgramasControllerActualizarEncuestaPrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, programasControllerActualizarEncuestaPrograma.PATH, 'put');
  if (params) {
    rb.path('uuidPrograma', params.uuidPrograma, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

programasControllerActualizarEncuestaPrograma.PATH = '/api/programas/actualizar-encuesta-programa/{uuidPrograma}';
